<!-- Workaround for load gloria food widget action not firing on iOS sometimes -->
<span
  [attr.data-glf-cuid]="gloriaFoodCuid"
  [attr.data-glf-ruid]="gloriaFoodRuid"
  ontouchend="setTimeout(() => { event.target.click() }, 100)"
>
  <a #triggerOrderNow class="btn btn-primary"> Order Now </a>
</span>
